<script>
import lazyLoadComponent from '@router/lazyload-component'
import BaseButtonDialog from '@components/BaseButtonDialog'
import {cloneDeep} from 'lodash'
import { questions } from '@utils/pet-question'

export default {
  components: {
    PetCommentList: () => lazyLoadComponent(import('@components/PetCommentList')),
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
    value: {
      type: Object,
      default: () => {},
    },
    defaultQuestions: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      // // pets: Array.from({ length: 5 }).fill(pet),
      // // pet,
      // questions:cloneDeep(questions),
      // petList: [],
      // dialogItem: {},
      // submitData: {
      //   questions: {
      //     personality: [],
      //     healthy: [],
      //     behavior: [],
      //     vaccine:0
      //   },
      // },
      // behavior:[],
      // healthy:[],
      // singlePetData: {},
      // dialogMode: 'edit', // edit 編輯, add 新增， view 預覽
      // // typeList,
      // // bodyTypeList,
      // // gender,
      // dialogVisible: false,
      // showDetail: false,
      // editDetailEnabled: false,
      // category: [],
      // // parentCategoryId: '',
      // parentCategoryIndex: 0,
      // tryingGet: false,
    }
  },
  computed: {
    // submitRules() {
    //   // const isTaiwan = this.submitData.phoneCode === '+886'
    //   return {
    //     avatar: [
    //       {
    //         required: true,
    //         message: '請上傳頭像',
    //         trigger: 'change',
    //       },
    //     ],
    //     name: [
    //       {
    //         required: true,
    //         message: '請填寫寵物名',
    //         trigger: 'blur',
    //       },
    //     ],
    //     categoryId: [
    //       {
    //         required: true,
    //         message: '請選擇類別',
    //         trigger: 'blur',
    //       },
    //     ],
    //     sizeId: [
    //       {
    //         required: true,
    //         message: '請選擇體型',
    //         trigger: 'blur',
    //       },
    //     ],
    //     gender: [
    //       {
    //         required: true,
    //         message: '請選擇性別',
    //         trigger: 'change',
    //       },
    //     ],
    //     birthday: [
    //       {
    //         required: true,
    //         message: '請選擇生日',
    //         trigger: 'blur',
    //         // trigger: 'change',
    //       },
    //     ],
    //   }
    // },
    // personalityContent(){
    //   return this.singlePetData.questions.personality.join('，')
    // },
    // healthyContent(){
    //   const content = this.singlePetData.questions.healthy.map(item =>{
    //     return `${item.title}${item.text?' ( ':''} ${item.text?item.text:''}${item.text?' )':''}`
    //   })
    //   return content.join('，')
    // },
    // behaviorContent(){
    //   const content = this.singlePetData.questions.behavior.map(item =>{
    //     return `${item.title}${item.text?' ( ':''} ${item.text?item.text:''}${item.text?' )':''}`
    //   })
    //   return content
    // },
    // vaccineContent(){
    //   let vaccine = ''
    //   switch (this.singlePetData.questions.vaccine) {
    //     case 1:
    //       vaccine = '1 劑'
    //       break;
    //     case 2:
    //       vaccine = '2 劑'
    //       break;
    //     case 3:
    //       vaccine = '3 劑'
    //       break;
    //     default:
    //       break;
    //   }
    //   return vaccine
    // }
  },
  // watch: {
  //   'submitData.categoryId': function () {
  //     this.getParentCategoryIndex()
  //     //  this.submitData.sizeId=''
  //   },
  //   behavior(val){
  //     if(val.length>0 && this.submitData.questions.behavior){
  //       this.submitData.questions.behavior=val.map(item=>{
  //         const selected = this.questions.behavior.find(i=>{
  //           return i.title === item
  //         }) 
  //         return selected
  //       })
  //     }else if(val.length===0 && this.submitData.questions.behavior){
  //       this.submitData.questions.behavior=[]
  //     }
      
  //   },
  //   healthy(val){
  //     if(val.length>0 && this.submitData.questions.healthy){
  //       this.submitData.questions.healthy=val.map(item=>{
  //         const selected = this.questions.healthy.find(i=>{
  //           return i.title === item
  //         }) 
  //         return selected
  //       })
  //     }else if(val.length===0 && this.submitData.questions.healthy){
  //       this.submitData.questions.healthy=[]
  //     }
      
  //   },
    
  //   //  "singlePetData.avatar":function(){
  //   //    console.log(123)
  //   //  }
  // },
  created() {
    // this.tryToFetchList()
    // this.tryToFetchCategory()
    
  },
  methods: {
    
    backToList() {
      this.$emit('back')
    },

  },
}
</script>

<template>
  <div :class="$style.DetailPets">
    <div>
      <BasePageHeader>
        <template v-slot:title>
          <el-button  class="is-round isStyleBase mr-4" @click="backToList">
            <BaseIcon name="arrow-left" />
            返回
          </el-button>
          <span style="vertical-align: middle;">服務紀錄</span>
        </template>
      </BasePageHeader>
    </div>
    <div class="isStylePageContent">
      <PetCommentList v-if="defaultValue.id" ref="commentAll" :order="undefined" :pet="defaultValue.id" type="pet" class-style="isStyleBgWhite" />
    </div>
  </div>
</template>

<style lang="scss" module>
.DetailPets {
  padding: 1.68rem 1rem 0;
  @include max-md {
    padding: 1rem 1rem 0;
  }
}
.petListImg {
  border-radius: 10px;
  overflow: hidden;
  height: 70px;
}
.pet {
  // font-size: 18px;
  :global {
    .danger {
      color: $color-state-danger;
    }
    .top {
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
    }
    .pet {
      &__back {
        cursor: pointer;
      }
      &__box {
        margin-bottom: 30px;
      }
      &__info {
        &__list {
        }
        &__item {
          margin-bottom: 18px;
        }
      }
    }
    .notice {
      margin-bottom: 30px;
      h5 {
        font-size: 18px;
      }
      line-height: 1.5;
    }
  }
}
</style>